import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Carousel from '../components/Carousel';
import Cascade from '../components/Cascade';
import Contacts from '../components/Contacts';
import Information from '../components/Information';
import Magazine from '../components/Magazine';
import MagicContent from '../components/MagicContent';
import Maintenance from '../components/Maintenance';
import Map from '../components/Map';
import Teaser from '../components/Teaser';
import Title from '../components/Title';
import PhotoBlog from '../components/gallery/PhotoBlog';
import NewsBlog from '../components/news/NewsBlog';
import ControlPanel from '../components/shared/ControlPanel';
import useCache from '../hooks/use-cache';
import { useGetContentQuery } from '../store';

export default function DynamicPage() {

    const params = useParams();
    const pageKey = params['*'] || 'home';

    let { data } = useCache(pageKey, useGetContentQuery, pageKey);
    const { token } = useSelector((state) => state.environment);

    data = data || [];

    const content = data.map((item) => {
        switch (item.controlType) {
            case 'Title':
                return <Title key={item.key} data={item}></Title>
            case 'Teaser':
                return <Teaser key={item.key} data={item.content}></Teaser>;
            case 'Magazine':
                return <Magazine key={item.key} data={item.content}></Magazine>;
            case 'Information':
                return <Information key={item.key} data={item.content}></Information>
            case 'Carousel':
                return <Carousel key={item.key} data={item.content}></Carousel>;
            case 'MagicContent':
                return <MagicContent key={item.key} data={item}></MagicContent>;
            //case 'Map':
            //    return <Map key={item.key} data={item}></Map>;
            case 'Contacts':
                return <Contacts key={item.key} data={item}></Contacts>
            case 'Cascade':
                return <Cascade key={item.key} data={item}></Cascade>
            case 'PhotoBlog':
                return <PhotoBlog key={item.key} data={item}></PhotoBlog>
            case 'NewsBlog':
                return <NewsBlog key={item.key} data={item}></NewsBlog>
            default:
                return null;
        }
    });

    return (
        <>

            <div>{content}</div>

            {!token && data.length === 1 && <Maintenance></Maintenance>}

            {token && <ControlPanel index={data.length + 1} partition={pageKey}></ControlPanel>}
        </>
    );
};